import CourseContext from "./CourseContext";
export default CourseContext.Consumer;
